import { useEffect, useState, useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";

// The end of the app bar a screen may write into (AppBar draws the place,
// a screen fills it), for a word the bar itself cannot know: "Paiement
// sécurisé" on the payment, a share on a booking.
export const APP_BAR_SLOT = "tk-appbar-slot";

/** Draws `children` at the end of the app bar while the screen is shown. */
export default function AppBarSlot({ children }) {
  const [slot, setSlot] = useState(null);
  useEffect(() => { setSlot(document.getElementById(APP_BAR_SLOT)); }, []);
  return slot ? createPortal(children, slot) : null;
}

// The name a screen gives its bar when the route's own says too little (a
// paid booking's bar names what was booked). One at a time, for its path.
let titled = null;
const listeners = new Set();
const emit = () => listeners.forEach((listener) => listener());
const subscribe = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };

/** Names the app bar `title` while the screen is shown; nothing keeps the route's name. */
export function useAppBarTitle(title) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!title) return undefined;
    const mine = { path: pathname, title };
    titled = mine;
    emit();
    return () => { if (titled === mine) { titled = null; emit(); } };
  }, [pathname, title]);
}

/** The name a screen gave the bar of `pathname`, if it gave one (AppHeader). */
export function useAppBarTitleFor(pathname) {
  const current = useSyncExternalStore(subscribe, () => titled, () => null);
  return current?.path === pathname ? current.title : null;
}
